import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../lib/cn';

export type BadgeVariant = 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

const variants: Record<BadgeVariant, string> = {
  default: 'bg-[var(--primary-light)] text-[var(--foreground)]',
  secondary: 'bg-[var(--secondary-light)] text-[var(--foreground)]',
  success: 'bg-[var(--success-light)] text-[var(--foreground)]',
  warning: 'bg-[var(--warning-light)] text-[var(--warning-text)]',
  destructive: 'bg-[var(--destructive-light)] text-[var(--foreground)]',
  outline: 'border border-[var(--border)] text-[var(--foreground)]',
};

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { className, variant = 'default', ...props },
  ref,
) {
  return <span className={cn('inline-flex items-center gap-1 rounded-[var(--radius-badge)] px-2 py-0.5 text-xs font-semibold', variants[variant], className)} ref={ref} {...props} />;
});
